<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { cn } from "@/lib/utils";

const props = defineProps<{
  class?: HTMLAttributes["class"];
}>();
</script>

<template>
  <div class="table-wrapper relative w-full overflow-auto">
    <table
      class="table"
      :class="cn('w-full caption-bottom text-sm', props.class)"
    >
      <slot />
    </table>
  </div>
</template>
<style scoped>
::-webkit-scrollbar {
  height: 6px;
  z-index: 100;
  position: relative;
}

::-webkit-scrollbar-thumb {
  background: #2e4a40;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2);
}
@media screen and (max-width: 768px) {
  .table {
    margin-bottom: 20px;
    min-width: 768px;
    overflow-x: scroll;
  }
}
</style>
